/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import {
  abortPreviousRequestsIfAny,
  getServiceProviderDetailsRatingReviewsUrlKey,
  getServiceProviderDetailsUrlKey,
} from "@/abort";
import { SERVICEPROVIDERIDS } from "@/constants";
import { useServiceProviderDetails } from "@/features/ServiceProviderSelection";
import { pickFromArray } from "@/utils";
import {
  IIServiceProviderDetail,
  IIServiceProviderRatingAndReview,
} from "@contract/electrify-v1";

export const useSoftQuote = () => {
  const {
    getRecommendedServiceProviderDetails,
    getRecommendedServiceProviderDetailReviews,
    serviceProviderDetails,
    setServiceProviderDetails,
  } = useServiceProviderDetails();
  const { getValues } = useFormContext();
  const [loading, setLoading] = useState(false);

  const doCheck = async () => {
    setLoading(true);

    let providers: IIServiceProviderDetail[] = [];
    try {
      providers = await getRecommendedServiceProviderDetails();
    } catch (e) {
      setLoading(false);
      setServiceProviderDetails(e as Error);
      return;
    }

    if (!providers || !providers.length) {
      setLoading(false);
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const ids = pickFromArray(providers, "id").flatMap((item) => item.id);
    sessionStorage.setItem(SERVICEPROVIDERIDS, ids.join(","));

    let ratings: IIServiceProviderRatingAndReview[] = [];
    try {
      ratings = await getRecommendedServiceProviderDetailReviews(ids.join(","));
    } catch (e) {
      setLoading(false);
      setServiceProviderDetails(e as Error);
      return;
    }

    const mergedDetails = providers.map((providerDetails) => {
      const ratingDetails = ratings.find((r) => r.id === providerDetails.id);
      return {
        ...providerDetails,
        ...ratingDetails,
      };
    });
    setServiceProviderDetails(mergedDetails);
    setLoading(false);
  };

  useEffect(() => {
    doCheck();

    return () => {
      // clean up
      abortPreviousRequestsIfAny(
        getServiceProviderDetailsUrlKey(getValues("selectedSystemSize")),
        getServiceProviderDetailsRatingReviewsUrlKey(
          sessionStorage.getItem(SERVICEPROVIDERIDS)
        )
      );
    };
  }, []);

  return {
    loading,
    serviceProviderDetails,
  };
};
